<template>
  <div class="goods-type-title">
    <div class="goods-type-title-left">
      <div class="left-title">{{ title }}</div>
      <div class="right-sub">好货常换 惊喜不断</div>
    </div>
    <div class="goods-type-title-right" @click="gotoPage">
      <span>更多</span><img src="../../../assets//images/right.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "img", "url"],
  methods: {
    gotoPage() {
      let text = this.$router.resolve({
        path: this.url,
      });
      window.open(text.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.goods-type-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
  .goods-type-title-left {
    display: flex;
    align-items: baseline;
    .left-title {
      font-size: 35px;
      color: #333333;
      margin-right: 20px;
    }
    .right-sub {
      font-size: 18px;
      color: #858585;
    }
  }
  .goods-type-title-right {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      color: #858585;
      font-size: 18px;
      margin-right: 10px;
    }
    img {
      width: 12px;
      height: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// title.vue?69e54154